import React from "react";
import { useEffect } from "react";
import { useState } from "react";
import Moment from "react-moment";

export default function PopupHistoricoPartida(props) {
  const [hist0, setHist0] = useState({});
  const [hist1, setHist1] = useState({});
  const [hist2, setHist2] = useState({});
  const [hist3, setHist3] = useState({});
  const [hist4, setHist4] = useState({});
  const [hist5, setHist5] = useState({});

  useEffect(() => {
    const abortController = new AbortController();

    if (props.historico !== null && props.historico.length > 0) {
      setHist0(props.historico[0]);

      if (props.historico[1] !== undefined) {
        setHist1(props.historico[1]);
      }

      if (props.historico[2] !== undefined) {
        setHist2(props.historico[2]);
      }

      if (props.historico[3] !== undefined) {
        setHist3(props.historico[3]);
      }

      if (props.historico[4] !== undefined) {
        setHist4(props.historico[4]);
      }

      if (props.historico[5] !== undefined) {
        setHist5(props.historico[5]);
      }
    }

    return function cleanup() {
      abortController.abort();
    };
  }, [props]);

  return (
    <>
      <div
        className="backdrop visible active"
        style={{ display: props.show === true ? "" : "none" }}
      />
      <div
        className="modal-match modal slide-in-up ng-enter active ng-enter-active"
        style={{
          display: props.show === true ? "" : "none",
          zIndex: "999",
          left: "0",
        }}
      >
        <div className="bar bar-header">
          <h1
            className="title ng-binding"
            style={{ left: "34px", right: "34px" }}
          >
            {props.title}
          </h1>
          <button className="button" onClick={() => props.fechar()}>
            x
          </button>
        </div>
        <div className="scroll-content ionic-scroll  has-header">
          <div
            className="scroll"
            style={{ transform: "translate3d(0px, 0px, 0px) scale(1)" }}
          >
            <div className="row">
              <div className="col col-60">
                <div className="info text-center">Último jogo</div>
                <ul>
                  <li>
                    <span className="img-icon acertos" />
                  </li>
                  <li>
                    <strong>{hist0.totalCorretas || 0}</strong>
                  </li>
                  <li>
                    <span>
                      Total de
                      <br />
                      acertos
                    </span>
                  </li>
                </ul>
              </div>
              <div className="col-40">
                <div className="info text-right">Histórico de jogadas</div>
                <div className="text-right">
                  <p
                    style={{
                      display: JSON.stringify(hist0) !== "{}" ? "" : "none",
                    }}
                  >
                    <span>{hist0?.totalCorretas}pt</span>
                    <small>
                      {" - "}
                      <Moment format="DD/MM/YYYY - HH:mm">
                        {hist0?.dataHoraCriacao}
                      </Moment>
                    </small>
                  </p>

                  <p
                    style={{
                      display: JSON.stringify(hist1) !== "{}" ? "" : "none",
                    }}
                  >
                    <span>{hist1?.totalCorretas}pt</span>
                    <small>
                      {" - "}
                      <Moment format="DD/MM/YYYY - HH:mm">
                        {hist1?.dataHoraCriacao}
                      </Moment>
                    </small>
                  </p>
                </div>
              </div>
            </div>
            <hr />
            <div className="row">
              <div className="col-60">
                <ul>
                  <li>
                    <span className="img-icon erros" />
                  </li>
                  <li>
                    <strong>
                      {hist0.totalQuestoes - hist0.totalCorretas || 0}
                    </strong>
                  </li>
                  <li>
                    <span>
                      Total de <br />
                      erros
                    </span>
                  </li>
                </ul>
              </div>
              <div className="col-40">
                <div className="text-right">
                  <p
                    style={{
                      display: JSON.stringify(hist2) !== "{}" ? "" : "none",
                    }}
                  >
                    <span>{hist2.totalCorretas}pt</span>
                    <small>
                      {" - "}
                      <Moment format="DD/MM/YYYY - HH:mm">
                        {hist2?.dataHoraCriacao}
                      </Moment>
                    </small>
                  </p>
                  <p
                    style={{
                      display: JSON.stringify(hist3) !== "{}" ? "" : "none",
                    }}
                  >
                    <span>{hist3.totalCorretas}pt</span>
                    <small>
                      {" - "}
                      <Moment format="DD/MM/YYYY - HH:mm">
                        {hist3?.dataHoraCriacao}
                      </Moment>
                    </small>
                  </p>
                </div>
              </div>
            </div>
            <hr />
            <div className="row">
              <div className="col-60">
                <ul>
                  <li>
                    <span className="img-icon percentual" />
                  </li>
                  <li>
                    <strong>
                      {" "}
                      {Math.floor(
                        (hist0.totalCorretas / hist0.totalQuestoes) * 100
                      ) || 0}
                      %
                    </strong>
                  </li>
                  <li>
                    <span>
                      Percentual <br />
                      de acertos
                    </span>
                  </li>
                </ul>
              </div>
              <div className="col-40">
                <div className="text-right">
                  <p
                    style={{
                      display: JSON.stringify(hist4) !== "{}" ? "" : "none",
                    }}
                  >
                    <span>{hist4.totalCorretas}pt</span>
                    <small>
                      {" - "}
                      <Moment format="DD/MM/YYYY - HH:mm">
                        {hist4?.dataHoraCriacao}
                      </Moment>
                    </small>
                  </p>

                  <p
                    style={{
                      display: JSON.stringify(hist5) !== "{}" ? "" : "none",
                    }}
                  >
                    <span>{hist5.totalCorretas}pt</span>
                    <small>
                      {" - "}
                      <Moment format="DD/MM/YYYY - HH:mm">
                        {hist5?.dataHoraCriacao}
                      </Moment>
                    </small>
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="scroll-bar scroll-bar-v">
            <div
              className="scroll-bar-indicator scroll-bar-fade-out"
              style={{
                transform: "translate3d(0px, 0px, 0px) scaleY(1)",
                height: "0px",
              }}
            />
          </div>
        </div>
      </div>
    </>
  );
}
